import React, { useEffect, useState } from 'react';
import { FiClock, FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import { formatSlaClock, slaRemainingMs } from '../utils/supportSlaClock';
import './SupportSlaClock.css';

/**
 * Live SLA countdown / overdue for a ticket's sla object from the API.
 */
export default function SupportSlaClock({ sla, size = 'md', className = '' }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!sla?.enabled || !sla.due_at || sla.frozen) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [sla?.enabled, sla?.due_at, sla?.frozen]);

  if (!sla?.enabled) return null;

  const remaining = slaRemainingMs(sla, now);
  const overdue = remaining != null && remaining < 0;
  const met = sla.frozen && sla.met === true;
  const missed = sla.frozen && sla.met === false;

  let label = 'SLA';
  if (met) label = 'Met';
  else if (missed || overdue) label = 'Overdue';
  else label = 'SLA';

  const clock = formatSlaClock(remaining, { compact: size === 'sm' });
  const title = sla.due_at
    ? `Due ${new Date(sla.due_at).toLocaleString()} · target ${sla.target_label || ''} for ${sla.priority || ''}`
    : undefined;

  return (
    <span
      className={`support-sla-clock support-sla-clock--${size}${
        overdue || missed ? ' is-overdue' : ''
      }${met ? ' is-met' : ''}${sla.frozen && !met && !missed ? ' is-frozen' : ''} ${className}`.trim()}
      title={title}
      role="status"
      aria-label={`${label} ${clock}${sla.target_label ? `, target ${sla.target_label}` : ''}`}
    >
      {overdue || missed ? (
        <FiAlertTriangle aria-hidden className="support-sla-icon" />
      ) : met ? (
        <FiCheckCircle aria-hidden className="support-sla-icon" />
      ) : (
        <FiClock aria-hidden className="support-sla-icon" />
      )}
      <span className="support-sla-label">{label}</span>
      <span className="support-sla-time" data-overdue={overdue || missed ? 'true' : 'false'}>
        {clock}
      </span>
      {sla.target_label && size !== 'sm' ? (
        <span className="support-sla-target">/{sla.target_label}</span>
      ) : null}
    </span>
  );
}
